import { toAbsoluteOffset } from "@artis/sdk";
import { formatMonthColumnText } from "@package/grid-utils";

import { FormulaError, type FunctionDef } from "./interpreter";

export const PERIOD: FunctionDef = {
  fn: (args) => {
    if (args.length !== 1) throw new FormulaError("#VALUE!");
    const offset = args[0]!.eval();
    const { normalized, error } = toAbsoluteOffset(typeof offset === "number" ? offset : String(offset));
    if (!normalized) throw new FormulaError("#VALUE!", error);
    return formatMonthColumnText(normalized);
  },
  params: ["offset"],
  description: "Period label, as shown in the grid, the offset points at now",
};
